/** The ways out of flow elements, for the flow checks that name one ("“Wrong key” leads nowhere."). */
const exitLabels = {
    Next: 'Toliau',
    'Wrong key': 'Neteisingas klavišas',
    'No key': 'Klavišas nepaspaustas',
    Open: 'Dirbama',
    Closed: 'Nedirbama',
    Answered: 'Atsiliepta',
    'Waited too long': 'Laukė per ilgai',
    'Nobody there': 'Nebuvo kam atsiliepti',
    'Asked for a callback': 'Paprašė perskambinti',
    'Not answered': 'Neatsiliepta',
    'On the list': 'Sąraše',
    'Not on it': 'Ne sąraše',
};
/**
 * Lithuanian for the messages made outside the screens: the server's errors
 * and the shared forms' checks (schemas.ts and the others). The API sends
 * them in the person's language; the apps translate the checks they run
 * themselves. Keys are the English texts exactly as the code writes them.
 */
export const messagesLt = {
    // ---- The API in general (http/) ----
    'Not found': 'Nerasta',
    'You do not have access to this.': 'Neturite prieigos prie šio turinio.',
    'Please sign in.': 'Prisijunkite.',
    'Something went wrong.': 'Kažkas nepavyko.',
    'Some fields need attention.': 'Patikrinkite pažymėtus laukus.',
    'That is already in use.': 'Tai jau naudojama.',
    'Already in use': 'Jau naudojama',
    'That file is too large.': 'Failas per didelis.',
    'The request body is not valid JSON.': 'Užklausos turinys nėra tinkamas JSON.',
    'Unknown site.': 'Nežinoma svetainė.',
    'Request refused.': 'Užklausa atmesta.',
    'Not a valid ID.': 'Neteisingas ID.',
    'Invalid cursor.': 'Neteisingas žymeklis.',
    'Choose an image file.': 'Pasirinkite paveikslėlio failą.',
    'Use a PNG, JPEG, WebP, SVG or ICO image.': 'Naudokite PNG, JPEG, WebP, SVG arba ICO paveikslėlį.',
    'Use a JPEG, PNG or WebP photo.': 'Naudokite JPEG, PNG arba WebP nuotrauką.',
    'This photo can’t be read. Use a JPEG, PNG or WebP photo.': 'Šios nuotraukos nepavyko nuskaityti. Naudokite JPEG, PNG arba WebP nuotrauką.',
    'Choose an audio file.': 'Pasirinkite garso failą.',
    'Use a WAV, MP3, OGG, M4A or WebM file.': 'Naudokite WAV, MP3, OGG, M4A arba WebM failą.',
    Taken: 'Toks pavadinimas jau yra',
    'Can’t change': 'Keisti negalima',
    'Unknown region': 'Nežinomas regionas',
    'Choose a region': 'Pasirinkite regioną',
    'Unknown person': 'Nežinomas darbuotojas',
    'No such person.': 'Tokio darbuotojo nėra.',
    'No such person': 'Tokio darbuotojo nėra',
    // ---- Signing in ----
    'Wrong email or password.': 'Neteisingas el. paštas arba slaptažodis.',
    'Too many attempts. Try again in {minutes} min.': 'Per daug bandymų. Bandykite po {minutes} min.',
    'Enter the code from your authenticator app.': 'Įveskite kodą iš autentifikavimo programėlės.',
    'That code is not right. Try the current one.': 'Kodas neteisingas. Įveskite dabartinį kodą.',
    'This account is suspended. Contact your provider.': 'Ši paskyra sustabdyta. Susisiekite su paslaugų teikėju.',
    'This link has expired or was already used. Ask your administrator for a new one.': 'Ši nuoroda nebegalioja arba jau buvo panaudota. Paprašykite administratoriaus naujos.',
    'This link has expired or was already used.': 'Ši nuoroda nebegalioja arba jau buvo panaudota.',
    'Not your current password': 'Tai ne jūsų dabartinis slaptažodis',
    // ---- The email with a password link (auth/password-mail.ts) ----
    'Your {product} account': 'Jūsų {product} paskyra',
    'A new {product} password': 'Naujas {product} slaptažodis',
    'Hello {name},': 'Sveiki,',
    'You have an account on {product}. To start, choose your password:': 'Jums sukurta {product} paskyra. Norėdami pradėti, nusistatykite slaptažodį:',
    'Your administrator made you a link to choose a new {product} password:': 'Administratorius sukūrė jums nuorodą naujam {product} slaptažodžiui nusistatyti:',
    'The link works once, until {time}. If it has expired, ask your administrator for a new one.': 'Nuoroda veikia vieną kartą, iki {time}. Jei ji nebegalioja, paprašykite administratoriaus naujos.',
    'Then sign in at {address} with this email address.': 'Tada prisijunkite adresu {address}, naudodami šį el. pašto adresą.',
    'If you didn’t ask for it, ignore this email: your password stays as it is.': 'Jei jos neprašėte, šį laišką galite ignoruoti: jūsų slaptažodis nepasikeis.',
    // ---- People, regions, branding, the platform console ----
    'Someone else must be a tenant admin first.': 'Pirmiausia administratoriumi turi būti paskirtas kitas darbuotojas.',
    'Ask another admin to reset your second factor.': 'Paprašykite kito administratoriaus iš naujo nustatyti jūsų dviejų žingsnių prisijungimą.',
    'Move the people in this region to another region first.': 'Pirmiausia perkelkite šio regiono darbuotojus į kitą regioną.',
    'This site has no branding yet.': 'Ši svetainė dar neturi savo išvaizdos.',
    'This tenant has no branding.': 'Ši įmonė neturi savo išvaizdos.',
    'That is the platform console’s hostname': 'Šį adresą naudoja platformos konsolė',
    // ---- Calls ----
    'Add your mobile number first: ask an administrator.': 'Pirmiausia turi būti įrašytas jūsų mobiliojo telefono numeris. Kreipkitės į administratorių.',
    'Calling is not available right now. Try again in a minute.': 'Skambinti šiuo metu negalima. Bandykite po minutės.',
    'The call could not be started.': 'Skambučio pradėti nepavyko.',
    'Emergency calls aren’t available here. Call from your mobile.': 'Pagalbos numeriais iš čia skambinti negalima. Skambinkite mobiliuoju telefonu.',
    'That isn’t a number we can call.': 'Šiuo numeriu paskambinti negalime.',
    'You don’t have a number to call from yet. Ask an administrator.': 'Dar neturite numerio, iš kurio galėtumėte skambinti. Kreipkitės į administratorių.',
    'That call can’t be made.': 'Šio skambučio atlikti negalima.',
    // Why a call was refused (calls.ts refusalText, and the API's answers to click-to-call).
    'Emergency numbers can’t be called from here. Use your mobile phone.': 'Pagalbos numeriais iš čia skambinti negalima. Naudokite mobilųjį telefoną.',
    'That isn’t a complete phone number.': 'Tai nėra pilnas telefono numeris.',
    'Calls to that country aren’t allowed for your region.': 'Jūsų regionui skambinti į šią šalį neleidžiama.',
    'Premium-rate numbers can’t be called.': 'Padidinto tarifo numeriais skambinti negalima.',
    'You have no number to call out from yet. Ask your administrator.': 'Dar neturite numerio, iš kurio galėtumėte skambinti. Kreipkitės į administratorių.',
    'No one has that extension.': 'Tokio vidinio numerio niekas neturi.',
    'Your calling minutes for today are used up.': 'Jūsų šiandienos skambučių minutės išnaudotos.',
    'The company’s calling minutes for today are used up.': 'Įmonės šiandienos skambučių minutės išnaudotos.',
    'You already have as many calls going as you’re allowed.': 'Jau turite tiek vykstančių skambučių, kiek leidžiama.',
    'All lines are busy. Try again in a minute.': 'Visos linijos užimtos. Bandykite po minutės.',
    'That person can’t take calls right now.': 'Šis darbuotojas šiuo metu negali priimti skambučių.',
    'The number is busy. Try again later.': 'Numeris užimtas. Bandykite vėliau.',
    'That number isn’t in use. Check it and try again.': 'Šis numeris nenaudojamas. Patikrinkite jį ir bandykite dar kartą.',
    'That number can’t be reached right now.': 'Šis numeris šiuo metu nepasiekiamas.',
    'The phone company’s line is busy or down. Try again in a minute.': 'Ryšio operatoriaus linija užimta arba neveikia. Bandykite po minutės.',
    'The phone company refused the call. If it keeps happening, tell your administrator.': 'Ryšio operatorius atmetė skambutį. Jei tai kartojasi, praneškite administratoriui.',
    'The phone company couldn’t put the call through. Try again in a minute.': 'Ryšio operatoriui nepavyko sujungti skambučio. Bandykite po minutės.',
    'The call couldn’t be made.': 'Skambučio atlikti nepavyko.',
    // ---- Recordings, voicemail, transcripts, AI reviews ----
    'The recording is not ready.': 'Įrašas dar neparuoštas.',
    'The recording is no longer available.': 'Įrašas nebepasiekiamas.',
    'This message is no longer available.': 'Ši žinutė nebepasiekiama.',
    'You have no recorded call going.': 'Šiuo metu neturite įrašomo pokalbio.',
    'The recording couldn’t be changed. Try again.': 'Įrašymo pakeisti nepavyko. Bandykite dar kartą.',
    'The call has no recording to transcribe.': 'Skambutis neturi įrašo, kurį būtų galima transkribuoti.',
    'The call has no transcript to correct.': 'Skambutis neturi transkripcijos, kurią būtų galima taisyti.',
    'Personal details in this line are hidden from you, so you can’t correct it.': 'Asmens duomenys šioje eilutėje jums paslėpti, todėl jos taisyti negalite.',
    'This call has no review.': 'Šis skambutis neįvertintas.',
    'Only reviewed sales calls can be corrected.': 'Taisyti galima tik įvertintus pardavimo skambučius.',
    'Unknown reason.': 'Nežinoma priežastis.',
    'There is a category with that name': 'Kategorija tokiu pavadinimu jau yra',
    // The sales review's sections and outcomes (apps/api/review-types).
    "Why the sale didn't go through": 'Kodėl pardavimas neįvyko',
    'What the customer needs': 'Ko reikia klientui',
    'Competitors named': 'Paminėti konkurentai',
    Objections: 'Prieštaravimai',
    'What went well': 'Kas pavyko',
    'To do differently next time': 'Ką kitą kartą daryti kitaip',
    'Next steps and promises': 'Tolesni veiksmai ir pažadai',
    'Sale agreed': 'Susitarta dėl pardavimo',
    'Follow-up agreed': 'Susitarta dėl tolesnių veiksmų',
    'No sale': 'Pardavimas neįvyko',
    'Not a sales conversation': 'Ne pardavimo pokalbis',
    // Insights: a reason without a category, and whom a weekly digest is about.
    Unknown: 'Nežinoma',
    Other: 'Kita',
    'The whole company': 'Visa įmonė',
    'A region': 'Regionas',
    Someone: 'Kažkas',
    // ---- Statistics ----
    'The start date is after the end date.': 'Pradžios data vėlesnė už pabaigos datą.',
    'Choose at most about a year.': 'Pasirinkite ne ilgesnį nei maždaug metų laikotarpį.',
    // ---- Notifications (the settings' answers) ----
    'Open the phone first.': 'Pirmiausia atidarykite telefoną.',
    'This browser’s push service is not supported.': 'Šios naršyklės pranešimų tarnyba nepalaikoma.',
    'This device can’t use that push service.': 'Šis įrenginys negali naudoti šios pranešimų tarnybos.',
    'Only iPhones have a separate token for calls.': 'Atskirą skambučių žetoną turi tik iPhone telefonai.',
    'That push service isn’t available here.': 'Ši pranešimų tarnyba čia nepasiekiama.',
    // ---- Notifications (titles and texts in the list) ----
    'Missed call from {from}': 'Praleistas skambutis: {from}',
    'Missed call': 'Praleistas skambutis',
    'New voicemail from {from}': 'Nauja balso žinutė: {from}',
    'New voicemail': 'Nauja balso žinutė',
    'Text from {from}': 'SMS žinutė: {from}',
    'New text': 'Nauja SMS',
    'Someone tried to call {number}': 'Kažkas bandė paskambinti numeriu {number}',
    '{name} tried to call {number}': '{name} bandė paskambinti numeriu {number}',
    'A call was blocked': 'Skambutis užblokuotas',
    'Not allowed.': 'Neleidžiama.',
    'An emergency number. Emergency calls aren’t connected yet: they were told to use their mobile.': 'Pagalbos numeris. Pagalbos skambučiai dar nesujungiami: darbuotojui pasakyta skambinti mobiliuoju telefonu.',
    'That country isn’t allowed for their region.': 'Darbuotojo regionui skambinti į šią šalį neleidžiama.',
    'A premium-rate number.': 'Padidinto tarifo numeris.',
    'Their calling minutes for today are used up.': 'Darbuotojo šiandienos skambučių minutės išnaudotos.',
    'The company’s calling minutes for today are used up. Calls out stop until tomorrow, or until your provider raises the cap.': 'Įmonės šiandienos skambučių minutės išnaudotos. Išeinantys skambučiai sustabdyti iki rytojaus arba kol paslaugų teikėjas padidins limitą.',
    'They already had as many calls going as allowed.': 'Darbuotojas jau turėjo tiek vykstančių skambučių, kiek leidžiama.',
    'All the company’s lines were busy (simultaneous call limit).': 'Visos įmonės linijos buvo užimtos (vienu metu leidžiamų skambučių limitas).',
    'Carrier {trunkName} is not connected': 'Ryšio operatorius „{trunkName}“ neprijungtas',
    'Status: {detail}. Calls through it may fail.': 'Būsena: {detail}. Skambučiai per jį gali nepavykti.',
    'Calls through it may fail.': 'Skambučiai per jį gali nepavykti.',
    'Call back {from}': 'Perskambinti: {from}',
    'A caller to call back': 'Skambinantysis, kuriam reikia perskambinti',
    '{queueName}: They hung up while waiting.': '{queueName}: skambinantysis padėjo ragelį laukdamas.',
    '{queueName}: Nobody answered in time.': '{queueName}: niekas laiku neatsiliepė.',
    '{queueName}: Nobody was there to answer.': '{queueName}: nebuvo kam atsiliepti.',
    '{queueName}: They asked to be called back.': '{queueName}: skambinantysis paprašė perskambinti.',
    'A caller has waited {minutes} min in {queueName}': 'Skambinantysis eilėje „{queueName}“ laukia jau {minutes} min.',
    'Nobody has answered yet.': 'Niekas dar neatsiliepė.',
    'Your team’s week: what went well, what to improve': 'Jūsų komandos savaitė: kas pavyko, ką tobulinti',
    'Your week: what went well, what to improve': 'Jūsų savaitė: kas pavyko, ką tobulinti',
    'Coaching points from last week’s calls.': 'Patarimai pagal praėjusios savaitės skambučius.',
    'Call reviews paused: the monthly AI budget is used up': 'DI pokalbių vertinimas sustabdytas: mėnesio DI biudžetas išnaudotas',
    '{budget} tokens this month. Reviews start again next month, or when the budget is raised.': 'Šį mėnesį išnaudota žetonų: {budget}. Vertinimas vėl prasidės kitą mėnesį arba kai biudžetas bus padidintas.',
    // ---- Contacts and the pipeline ----
    '{e164} is {name}’s number already.': '{e164} jau yra kontakto „{name}“ numeris.',
    '{e164} is {name}’s': '{e164} jau yra kontakto „{name}“ numeris',
    'Another lead has this number already.': 'Šį numerį jau turi kitas potencialus klientas.',
    'Another lead has this number already': 'Šį numerį jau turi kitas potencialus klientas',
    '{who} has this number already.': '„{who}“ jau turi šį numerį.',
    '{who} has this number already': '„{who}“ jau turi šį numerį',
    // The pipeline's spreadsheet (export): the sheet, its headings, stages and call outcomes (as the web app words them).
    Pipeline: 'Pardavimų eiga',
    Company: 'Įmonė',
    'Contact person': 'Kontaktinis asmuo',
    Position: 'Pareigos',
    Number: 'Numeris',
    Email: 'El. paštas',
    'What they do': 'Veikla',
    'Interested in': 'Domina',
    Source: 'Šaltinis',
    Stage: 'Etapas',
    'Next call': 'Kitas skambutis',
    'Who works it': 'Atsakingas',
    'Calls not answered': 'Neatsilieptų skambučių',
    'Last call': 'Paskutinis skambutis',
    'Last call ended': 'Paskutinio skambučio baigtis',
    Notes: 'Pastabos',
    Added: 'Pridėta',
    'To call': 'Skambinti',
    'No answer': 'Neatsiliepė',
    'Not interested': 'Nesudomino',
    Interested: 'Sudomino',
    'Follow up': 'Perskambinti',
    Done: 'Atlikta',
    Cancelled: 'Atšaukta',
    Answered: 'Atsiliepta',
    Missed: 'Praleista',
    Voicemail: 'Balso paštas',
    Busy: 'Užimta',
    Failed: 'Nepavyko',
    'Not allowed': 'Neleista',
    // ---- SmartOn (CRM) ----
    'SmartOn could not be reached': 'Nepavyko susisiekti su SmartOn',
    'SmartOn did not answer in time': 'SmartOn laiku neatsakė',
    'This address does not look like a SmartOn with phone system support': 'Šis adresas nepanašus į SmartOn su telefonijos sistemos palaikymu',
    'SmartOn refused the API key': 'SmartOn nepriėmė API rakto',
    'SmartOn answered {status}': 'SmartOn grąžino klaidą {status}',
    'No API key is saved': 'API raktas neišsaugotas',
    'Use the https:// address': 'Naudokite https:// adresą',
    'Enter the API key from SmartOn': 'Įveskite API raktą iš SmartOn',
    'Enter the company’s SmartOn address, e.g. https://yourcompany.smarton.app': 'Įveskite įmonės SmartOn adresą, pvz., https://yourcompany.smarton.app',
    // ---- Carriers and numbers ----
    'Another account on this server already uses one of these carrier addresses.': 'Kita šio serverio paskyra jau naudoja vieną iš šių ryšio operatoriaus adresų.',
    'Already used on this server. Use a username and password with this carrier instead.': 'Jau naudojama šiame serveryje. Su šiuo ryšio operatoriumi naudokite naudotojo vardą ir slaptažodį.',
    'This carrier account is already connected.': 'Ši ryšio operatoriaus paskyra jau prijungta.',
    'Already connected on this server': 'Jau prijungta šiame serveryje',
    'Enter the account password': 'Įveskite paskyros slaptažodį',
    'Move or delete this trunk’s numbers first.': 'Pirmiausia perkelkite arba ištrinkite šio ryšio operatoriaus numerius.',
    'Unknown trunk': 'Nežinomas ryšio operatorius',
    'Unknown queue': 'Nežinoma eilė',
    'Unknown call flow': 'Nežinomas skambučių scenarijus',
    'The call flow is another region’s': 'Šis skambučių scenarijus priklauso kitam regionui',
    'A number rings a person, leads to a queue or starts a call flow: one of them': 'Numeris skambina darbuotojui, veda į eilę arba paleidžia skambučių scenarijų – tik vienas iš jų',
    // ---- Queues, hold music, call rules ----
    'There is a queue with that name already.': 'Eilė tokiu pavadinimu jau yra.',
    'Numbers lead to this queue. Point them elsewhere first.': 'Į šią eilę veda numeriai. Pirmiausia nukreipkite juos kitur.',
    'Unknown hold music': 'Nežinoma laukimo muzika',
    'That music is another region’s': 'Ši muzika priklauso kitam regionui',
    'Someone is in the list twice': 'Kažkas sąraše yra du kartus',
    'There is hold music with that name already.': 'Laukimo muzika tokiu pavadinimu jau yra.',
    'Hold music stays in its region.': 'Laukimo muzikos negalima perkelti į kitą regioną.',
    'Queues play this music: {join}.': 'Šią muziką groja eilės: {join}.',
    'Choose a colleague': 'Pasirinkite kolegą',
    'Choose a queue': 'Pasirinkite eilę',
    'Choose a date': 'Pasirinkite datą',
    'Choose the last day': 'Pasirinkite paskutinę dieną',
    'The last day is before the first': 'Paskutinė diena ankstesnė už pirmąją',
    // ---- Call flows and their parts ----
    'There is a flow with that name already.': 'Scenarijus tokiu pavadinimu jau yra.',
    'A flow stays in its region.': 'Scenarijaus negalima perkelti į kitą regioną.',
    'Numbers start this flow. Point them elsewhere first.': 'Šį scenarijų paleidžia numeriai. Pirmiausia nukreipkite juos kitur.',
    'Other flows go to this one: {join}.': 'Į šį scenarijų pereina kiti scenarijai: {join}.',
    'Nothing is published yet: test the draft.': 'Dar niekas nepaskelbta: išbandykite juodraštį.',
    'Fix the marked elements first.': 'Pirmiausia ištaisykite pažymėtus elementus.',
    '“{name}” has no recording yet.': '„{name}“ dar neturi įrašo.',
    'Only the region’s numbers': 'Tik šio regiono numeriai',
    'There is a prompt with that name already.': 'Garso pranešimas tokiu pavadinimu jau yra.',
    'A prompt stays in its region.': 'Garso pranešimo negalima perkelti į kitą regioną.',
    'Flows play this prompt: {join}.': 'Šį garso pranešimą groja scenarijai: {join}.',
    'There are opening hours with that name already.': 'Darbo laiko grafikas tokiu pavadinimu jau yra.',
    'Opening hours stay in their region.': 'Darbo laiko grafiko negalima perkelti į kitą regioną.',
    'Flows check these hours: {join}.': 'Šį grafiką tikrina scenarijai: {join}.',
    'There is a list with that name already.': 'Sąrašas tokiu pavadinimu jau yra.',
    'A list stays in its region.': 'Sąrašo negalima perkelti į kitą regioną.',
    'Flows check this list: {join}.': 'Šį sąrašą tikrina scenarijai: {join}.',
    // What a flow needs before it can be published (flows.ts validateFlow).
    'The flow needs a Start.': 'Scenarijuje turi būti elementas „Pradžia“.',
    'A flow has one Start.': 'Scenarijuje gali būti tik vienas elementas „Pradžia“.',
    'Choose the prompt the menu plays.': 'Pasirinkite garso pranešimą, kurį groja meniu.',
    'Choose at least one key.': 'Pasirinkite bent vieną klavišą.',
    'Choose the prompt to play.': 'Pasirinkite, kurį garso pranešimą groti.',
    'Choose the opening hours.': 'Pasirinkite darbo laiko grafiką.',
    'Choose the queue.': 'Pasirinkite eilę.',
    'Choose whose missed-call list it goes on (a queue).': 'Pasirinkite eilę, į kurios perskambinimų sąrašą bus įtrauktas skambinantysis.',
    'Choose who gets the messages.': 'Pasirinkite, kas gaus žinutes.',
    'Choose the queue whose members get the messages.': 'Pasirinkite eilę, kurios nariai gaus žinutes.',
    'The greeting no longer exists.': 'Pasirinkto pasisveikinimo nebėra.',
    'Enter the number to transfer to.': 'Įveskite numerį, į kurį peradresuoti.',
    'Choose who to transfer to.': 'Pasirinkite, kam peradresuoti.',
    'Choose the caller list.': 'Pasirinkite skambintojų sąrašą.',
    'Choose the flow to go to (one that is published).': 'Pasirinkite scenarijų, į kurį pereiti (paskelbtą).',
    'Choose the language.': 'Pasirinkite kalbą.',
    'Each key once.': 'Kiekvienas klavišas – tik vieną kartą.',
    ...Object.fromEntries(Object.entries(exitLabels).flatMap(([en, lt]) => [
        [`“${en}” leads to two places: keep one.`, `Išėjimas „${lt}“ veda į dvi vietas: palikite vieną.`],
        [`“${en}” leads to an element that is gone.`, `Išėjimas „${lt}“ veda į elementą, kurio nebėra.`],
        [`“${en}” leads nowhere.`, `Išėjimas „${lt}“ niekur neveda.`],
    ])),
    // A named period (Lunch) or a menu key: the name as it is.
    '“{label}” leads to two places: keep one.': 'Išėjimas „{label}“ veda į dvi vietas: palikite vieną.',
    '“{label}” leads to an element that is gone.': 'Išėjimas „{label}“ veda į elementą, kurio nebėra.',
    '“{label}” leads nowhere.': 'Išėjimas „{label}“ niekur neveda.',
    'No call can reach this element.': 'Į šį elementą nepateks joks skambutis.',
    'Calls here go round in a loop with no way out.': 'Skambučiai čia sukasi ratu be išėjimo.',
    // The simulator: each step's note (flow-engine.ts), the more specific ones first.
    'Too many times round: goodbye': 'Per daug ratų: atsisveikinama',
    'Call comes in': 'Gaunamas skambutis',
    'Counted: {label}': 'Suskaičiuota: {label}',
    Counted: 'Suskaičiuota',
    'Language: {language}': 'Kalba: {language}',
    '{hours}: Opening hours missing: closed': '{hours}: grafiko nėra – nedirbama',
    // The weekday stays out: it would be in English, and the date says it. (A named
    // period's note stays as it is: a key for it would match too much.)
    '{hours}: Open ({day} {date} {time})': '{hours}: dirbama ({date} {time})',
    '{hours}: Closed ({day} {date} {time})': '{hours}: nedirbama ({date} {time})',
    '{caller} is not on {list}': '{caller} nėra sąraše „{list}“',
    '{caller} is on {list}': '{caller} yra sąraše „{list}“',
    'Callback task for {queue}, emailed to {email}': 'Įtraukta į perskambinimų sąrašą: {queue}, išsiųsta adresu {email}',
    'Callback task for {queue}': 'Įtraukta į perskambinimų sąrašą: {queue}',
    'Go to {flow}': 'Pereinama į „{flow}“',
    'Play {prompt}: played': 'Garso pranešimas „{prompt}“: sugrotas',
    'Play {prompt}': 'Garso pranešimas „{prompt}“',
    'Menu {prompt}: no key pressed': 'Meniu „{prompt}“: klavišas nepaspaustas',
    'Menu {prompt}: pressed {key} (not a choice)': 'Meniu „{prompt}“: paspaustas {key} (tokio pasirinkimo nėra)',
    'Menu {prompt}: pressed {key}': 'Meniu „{prompt}“: paspaustas {key}',
    'Menu {prompt}': 'Meniu „{prompt}“',
    'Queue {queue}: answered': 'Eilė „{queue}“: atsiliepta',
    'Queue {queue}: waited too long': 'Eilė „{queue}“: laukė per ilgai',
    'Queue {queue}: nobody there': 'Eilė „{queue}“: nėra kam atsiliepti',
    'Queue {queue}: asked for a callback': 'Eilė „{queue}“: paprašė perskambinti',
    'Queue {queue}': 'Eilė „{queue}“',
    'Transfer to {who}: answered': 'Peradresavimas ({who}): atsiliepta',
    'Transfer to {who}: not answered': 'Peradresavimas ({who}): neatsiliepta',
    'Transfer to {who}': 'Peradresavimas ({who})',
    'Voicemail for {who}': 'Balso paštas ({who})',
    'Hang up': 'Baigti skambutį',
    // How the simulated call ends.
    'Answered in {queue}': 'Atsiliepta eilėje „{queue}“',
    'Answered by {who}': 'Atsiliepė {who}',
    'Leaves a message for {who}': 'Palieka balso žinutę ({who})',
    'Hung up: went round too many times': 'Skambutis baigtas: per daug ratų',
    'Hung up: a way out leads nowhere': 'Skambutis baigtas: išėjimas niekur neveda',
    'Hung up': 'Skambutis baigtas',
    // ---- Form checks (schemas.ts and the others) ----
    'Use at least 12 characters': 'Naudokite bent 12 simbolių',
    'Use a colour like #2459D6': 'Naudokite spalvos kodą, pvz., #2459D6',
    'Not a valid hostname': 'Netinkamas domeno vardas',
    'Use the international format, e.g. +37061234567': 'Naudokite tarptautinį formatą, pvz., +37061234567',
    'Use 2 to 6 digits': 'Naudokite nuo 2 iki 6 skaitmenų',
    'That is an emergency number': 'Tai pagalbos numeris',
    'Use a two-letter country code, e.g. LT': 'Naudokite dviejų raidžių šalies kodą, pvz., LT',
    'Use a two-letter language code, e.g. lt': 'Naudokite dviejų raidžių kalbos kodą, pvz., lt',
    'Not a known time zone': 'Nežinoma laiko juosta',
    'Enter the 6-digit code': 'Įveskite 6 skaitmenų kodą',
    'Add at least one language': 'Pridėkite bent vieną kalbą',
    // A whole number in a range (the largest ones all take the genitive plural).
    'Use {min} to {max} days': 'Nuo {min} iki {max} dienų',
    'Use {min} to {max} seconds': 'Nuo {min} iki {max} sekundžių',
    'Use {min} to {max} minutes': 'Nuo {min} iki {max} minučių',
    'Use {min} to {max} calls': 'Nuo {min} iki {max} skambučių',
    'Use {min} to {max} texts': 'Nuo {min} iki {max} SMS',
    'Use 1 to 10': 'Nuo 1 iki 10',
    'Use a hostname or address, with :port if not 5060': 'Įveskite serverio vardą arba adresą, su :prievadu, jei jis ne 5060',
    'Use a domain or address, e.g. 203.0.113.10': 'Įveskite domeną arba adresą, pvz., 203.0.113.10',
    'Use an IPv4 address or range, e.g. 185.45.152.0/24': 'Įveskite IPv4 adresą arba intervalą, pvz., 185.45.152.0/24',
    'Enter the account name': 'Įveskite paskyros vardą',
    'Add the carrier’s addresses': 'Pridėkite ryšio operatoriaus adresus',
    'Use YYYY-MM-DD': 'Naudokite formatą MMMM-MM-DD',
    'Use HH:MM': 'Naudokite formatą VV:MM',
    'Use a model name, e.g. large-v3, or a Hugging Face repository': 'Įveskite modelio pavadinimą, pvz., large-v3, arba Hugging Face saugyklą',
    'At most 2000 characters': 'Ne daugiau kaip 2000 simbolių',
    'At least 0': 'Ne mažiau kaip 0',
    'At most 3650 days (10 years)': 'Ne daugiau kaip 3650 dienų (10 metų)',
    'Enter the service’s address': 'Įveskite paslaugos adresą',
    'Enter a name': 'Įveskite pavadinimą',
    'Enter the endpoint’s address': 'Įveskite API adresą',
    'Enter the model name': 'Įveskite modelio pavadinimą',
    'Give a name': 'Įveskite vardą',
    'Give it a name': 'Įveskite pavadinimą',
    'Not an email address': 'Tai ne el. pašto adresas',
    'A number is in the list twice': 'Sąraše tas pats numeris yra du kartus',
    'Pick a date': 'Pasirinkite datą',
    'Give a company or a name': 'Įveskite įmonę arba vardą',
    'Give a name, number or email': 'Įveskite vardą, numerį arba el. paštą',
    'A number with the country code, e.g. +370 600 00000': 'Numeris su šalies kodu, pvz., +370 600 00000',
    'Numbers with the country code, e.g. +37060000000': 'Numeriai su šalies kodu, pvz., +37060000000',
    'No colons in a period’s name': 'Laikotarpio pavadinime negali būti dvitaškio',
    'Ends before it starts': 'Baigiasi anksčiau, nei prasideda',
    // ---- Zod's own messages, for checks without a message of ours ----
    'Too small: expected string to have >=1 characters': 'Užpildykite šį lauką',
    'Too small: expected string to have >={minimum} characters': 'Įveskite bent {minimum} simb.',
    'Too big: expected string to have <={maximum} characters': 'Ne daugiau kaip {maximum} simb.',
    'Too small: expected array to have >={minimum} items': 'Reikia bent {minimum}',
    'Too big: expected array to have <={maximum} items': 'Ne daugiau kaip {maximum}',
    'Too small: expected number to be >={minimum}': 'Ne mažiau kaip {minimum}',
    'Too big: expected number to be <={maximum}': 'Ne daugiau kaip {maximum}',
    'Invalid input: expected number, received {received}': 'Įveskite skaičių',
    'Invalid input: expected string, received {received}': 'Užpildykite šį lauką',
    'Invalid input: expected {expected}, received {received}': 'Neteisinga reikšmė',
    'Invalid option: expected one of {options}': 'Pasirinkite iš sąrašo',
    'Invalid string: must match pattern {pattern}': 'Neteisingas formatas',
    'Invalid email address': 'Neteisingas el. pašto adresas',
    'Invalid UUID': 'Pasirinkite iš sąrašo',
    'Invalid URL': 'Neteisingas adresas',
    'Invalid input': 'Neteisinga reikšmė',
    // ---- Texts (SMS) ----
    'Texts are off for this number. An admin can turn them on in Settings, Numbers.': 'Šiam numeriui SMS išjungtos. Administratorius gali jas įjungti skiltyje „Nustatymai“, „Numeriai“.',
    'They texted from a name, not a number, so there is nothing to reply to.': 'Žinutė atsiųsta su vardu, o ne numeriu, todėl atsakyti nėra kam.',
    'You have sent today’s {limit} texts. You can send more tomorrow.': 'Šiandien jau išsiuntėte {limit} SMS. Daugiau galėsite siųsti rytoj.',
    'Write the text': 'Parašykite žinutę',
    'Enter the number': 'Įveskite numerį',
    'Not a number that can get texts': 'Šiuo numeriu SMS išsiųsti negalima',
    'Texts to that country aren’t allowed from this number': 'Iš šio numerio SMS į tą šalį siųsti neleidžiama',
    'You can’t text from this number': 'Iš šio numerio jūs SMS siųsti negalite',
    'Its carrier doesn’t pass texts: turn texts on for the carrier first': 'Šio numerio ryšio operatorius SMS neperduoda: pirmiausia įjunkite SMS operatoriui',
    'The phone system could not send it.': 'Telefonų sistemai nepavyko jos išsiųsti.',
    'The phone system is not connected. Try again in a minute.': 'Telefonų sistema neprisijungusi. Pabandykite po minutės.',
};
